var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v("Conversion Rate (Actual %)")]),_c('div',{attrs:{"id":"ConversionRatesChart"}})])
}]

export { render, staticRenderFns }